import {Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges} from '@angular/core';
import {FilterAbstractModel} from '../../../../models/FilterAbstractModel';
import {RoleAnagrafModel} from '../../../../models/RoleAnagrafModel';
import {Subscription} from 'rxjs';
import {RoleAnagrafService} from 'src/app/general-services/service-role-anagraf/role-anagraf.service';

@Component({
  selector: 'app-role-anagraf-filter',
  templateUrl: './role-anagraf-filter.component.html',
  styleUrls: ['./role-anagraf-filter.component.scss']
})
export class RoleAnagrafFilterComponent extends FilterAbstractModel implements OnInit, OnChanges, OnDestroy {

  listFilterRoles: any;
  getAllRateRoleSubscribe: Subscription;

  @Input() rolesSelected: RoleAnagrafModel;

  constructor(private rateRoleService: RoleAnagrafService) {
    super();
  }

  ngOnInit() {
    this.getAll();
  }

  ngOnChanges(changes: SimpleChanges) {
    if ('rolesData' in changes) {
      this.optionSelected = this.listFilterRoles ? this.listFilterRoles[0] : null;
    }
    if (this.rolesSelected) {
      this.optionSelected = this.rolesSelected;
    }
  }

  getAll() {
    this.getAllRateRoleSubscribe = this.rateRoleService.getList()
      .subscribe(
        (result: any) => {
          this.listFilterRoles = result;
        });
  }

  ngOnDestroy(): void {
  }
}
